import type { FC, ReactNode } from 'react';

import { InfoCardWrapStyled } from './InfoCard.styled';

export type InfoCardPropsT = {
  children: ReactNode;
  className?: string;
  compact?: boolean;
  fullWidth?: boolean;
};

const InfoCard: FC<InfoCardPropsT> = ({
  children,
  className,
  compact = false,
  fullWidth = true,
}): JSX.Element => {
  return (
    <InfoCardWrapStyled className={className} compact={compact} fullWidth={fullWidth} tabIndex={0}>
      {children}
    </InfoCardWrapStyled>
  );
};

export default InfoCard;
